import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Cell } from 'react-md';
import MultiSelectReact from 'react-multi-select-ext';
import { NotificationManager } from 'react-notifications';
import ApiRequestService from '../component/ApiRequestService';
import LoadingSpinner from '../component/LoadingSpinner';

const selectedOptionsStyles = {
    color: '#FFFFFF',
    backgroundColor: '#bb0000'
};
const optionsListStyles = {
    backgroundColor: '#FFFFFF',
    color: '#bb0000' 
};



export default class CategoryDropDown extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
          categoryListArray: [],
          selectedCategoryIDs:-1,
          loading: true
        };
      }

      
    //Loads All Categorys for a given course on Component Mount
    componentWillMount() {
        if(this.props.archiveMode && this.props.categoryMap){

            let categoryArray    =   this.props.categoryMap[this.props.selectedCourseID].map(
                this.makeCategorylistArrayArchive
                );
            this.setState({categoryListArray:categoryArray,loading: false},()=>{
                this.props.onChange(categoryArray);
            });
        }
        else 
            this.updateCategorys(this.props.selectedCourseID, this.props.selectedSectionID);
    }

    componentWillReceiveProps(nextProps)
    {
        
        if((this.props.selectedCourseID !== nextProps.selectedCourseID) && (this.props.selectedSectionID !== nextProps.selectedSectionID))
        {
            this.setState({loading:true})
            this.updateCategorys(nextProps.selectedCourseID, nextProps.selectedSectionID);
            
        }
    }
    //Update Categorys
    updateCategorys = (selectedCourseID, selectedSectionID) => 
    {
        if(selectedCourseID <= 0)
            return;
          
        if(!selectedSectionID)
            return;
          
        let parent = this;
        let categoryListPromise =   this.getCategoryData(selectedCourseID, selectedSectionID);
         categoryListPromise.then(categoryList => {
            if(categoryList.length > 0 )
            {
                let categoryArray    =   categoryList.map(
                    this.makeCategorylistArray
                    );
                parent.setState({categoryListArray:categoryArray,loading: false},()=>{
                    parent.props.onChange(categoryArray);
                });
            }else{
                NotificationManager.error('Selected Section has no Category. Please select a different Section.','ERROR');
                parent.props.emptyData()
                parent.setState({loading:false})
            }
            
        }).catch(error => {
            console.error("error retriving categorys ",error);
            this.setState({loading:false});
            console.debug(error,"Error - Empty Response");
        })
    }
    //Create an Array of CategoryList for Select Box
    makeCategorylistArray(categoryObj, index) {
        console.debug("dddd ",categoryObj, index)

        return {
            index:categoryObj.category_id,
            label: categoryObj.category_name,
            value: false,
            id:index,
            subjectId:categoryObj.subject_id,
            topicId:categoryObj.topic_id
        };
    }

    makeCategorylistArrayArchive(categoryObj, index) {
        console.debug("dddd ",categoryObj, index)
        return {
            index: categoryObj.value,
            label: categoryObj.label,
            value: true,
            id:categoryObj.value
        };
    }
    

    getCategoryData = (req_course_id, req_section_id) => {
        const payload = { course_id: req_course_id ,section_id: req_section_id};
        let URL = this.props.graded ? '/getCategoriesForSection' : '/getNonGradedCategoriesForSection'
    this.setState({loading:true})
        return new Promise(function(resolve, reject) {
          ApiRequestService({
            method: 'post',
            url: URL,
            data: payload
          })
            .then(res => {
              if (
                res.data.data !== null &&
                res.data.data !== undefined &&
                res.data.data.length > 0
              ) {
                return resolve(res.data.data);
              } else {
                let emptyArray = [];
                return resolve(emptyArray);
              }
            })
            .catch(error => {
              console.error('Error When Retriving Category Details ', error);
              reject(error, null);
            });
        });
      }
    //Memoize Function to stop hitting Go Server on Every Request
    //getCategoryData = iMemoized.memoize(this.getCategoryData);
    
    onCategoryChange = (
        argSelectedCategoryIDs) => {    
        this.setState({
          selectedCategoryIDs: argSelectedCategoryIDs,
        });
        if(this.props.onChange !== undefined && this.props.onChange !== null)
            this.props.onChange(argSelectedCategoryIDs);
    };

    render(){

        if(this.state.loading)
        {
            return   <LoadingSpinner loading={this.state.loading} />
        }

        return <Cell  size={12} phoneSize={4} tabletSize={6} >
        <label htmlFor="categorySelectBox">Category </label>
            {
                this.state.categoryListArray && this.state.categoryListArray.length > 0 ?
                    (<MultiSelectReact
                        options={this.state.categoryListArray}
                        optionClicked={this.onCategoryChange}
                        selectedBadgeClicked={this.onCategoryChange}
                        selectedOptionsStyles={selectedOptionsStyles}
                        optionsListStyles={optionsListStyles}
                        enableSelectAllNone={true}
                    />)
                :
                <p>No Category found</p>
            }
</Cell>
    }
}

CategoryDropDown.propTypes = {
    onChange: PropTypes.func,
    className:PropTypes.string,
    placeholder:PropTypes.string,
    selectBoxID:PropTypes.string.isRequired,
    archiveMode:PropTypes.bool
    };